// You can write your custom Javascript here
if(document.getElementsByClassName('discover-btn').length > 0){
  document.getElementsByClassName('discover-btn')[0].addEventListener('mouseover', () => {
    let discoverMenu = document.getElementsByClassName('menu--discover')[0].getElementsByClassName('dropdown__menu')[0]
    discoverMenu.style.borderTop = "1px solid #c8c8c8"
    discoverMenu.style.maxHeight = "1000px"
    document.getElementsByTagName('body')[0].classList.add('no-scroll');
  })
  document.getElementsByClassName('discover-btn')[0].addEventListener('mouseout', () => {
    let discoverMenu = document.getElementsByClassName('menu--discover')[0].getElementsByClassName('dropdown__menu')[0]
    discoverMenu.style.removeProperty('border-top');
    discoverMenu.style.removeProperty('max-height');
    document.getElementsByTagName('body')[0].classList.remove('no-scroll');
  })
}